import _sfc_main from "./StreamRegionPC.vue2.mjs";
/* empty css                     */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { ref: "streamRegionContainerRef", staticClass: "stream-region-container" }, [_c("div", { directives: [{ name: "dbl-touch", rawName: "v-dbl-touch", value: _setup.handleStreamDblClick, expression: "handleStreamDblClick" }], staticClass: "stream-region", style: _setup.streamStyle, on: { "stream-view-dblclick": _setup.handleStreamDblClick } }, [_setup.isLocalScreen ? _c(_setup.LocalScreenView, { attrs: { "streamInfo": _vm.streamInfo } }) : [_c(_setup.StreamPlay, { directives: [{ name: "touch-scale", rawName: "v-touch-scale", value: _setup.props.supportTouchScale, expression: "props.supportTouchScale" }], attrs: { "streamInfo": _vm.streamInfo, "stream-play-mode": _vm.streamPlayMode, "stream-play-quality": _vm.streamPlayQuality } }), _c(_setup.StreamCover, { attrs: { "streamInfo": _vm.streamInfo } })]], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "041784be"
);
const StreamRegion = __component__.exports;
export {
  StreamRegion as default
};
